module.exports = __webpack_public_path__ + "static/img/city_04.b8be3aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile@1x/pic/city_04.png
// module id = vc9H
// module chunks = 0